import React, { useRef, useState } from 'react';
import { usePortal } from '../../contexts/PortalContext';
import type { Project } from '../../types/portal';
import { projectStatus } from '../../utils/status';
import { BUTTON_QUIET, BUTTON_SOLID, FIELD } from './adminStyles';
export function ProjectFields({
  onClose
}: {
  onClose: () => void;
}) {
  const {
    activeProject,
    updateProject,
    notify
  } = usePortal();
  const [draft, setDraft] = useState<Project>(activeProject);
  const fileInput = useRef<HTMLInputElement>(null);
  function edit(patch: Partial<Project>) {
    setDraft(current => ({
      ...current,
      ...patch
    }));
  }
  function uploadCallSheet(event: React.ChangeEvent<HTMLInputElement>) {
    const file = event.target.files?.[0];
    if (!file) return;
    edit({
      callSheet: {
        fileName: file.name,
        url: URL.createObjectURL(file)
      }
    });
    event.target.value = '';
  }
  function save(event: React.FormEvent) {
    event.preventDefault();
    updateProject({
      client: draft.client.trim() || activeProject.client,
      name: draft.name.trim() || activeProject.name,
      type: draft.type,
      description: draft.description,
      nextShootDate: draft.nextShootDate,
      nextShootTime: draft.nextShootTime,
      callSheet: draft.callSheet,
      location: draft.location,
      clientContact: draft.clientContact,
      producer: draft.producer
    });
    notify('Project details updated');
    onClose();
  }
  return <form onSubmit={save} className="mt-10 border border-paper/25 px-6 py-8 sm:px-8" data-id="element-346" data-mp="7wqz5t6u12bl">
      <h3 className="font-display text-2xl leading-none" data-id="element-347" data-mp="2wutlpihl2tx">Edit Project</h3>

      <div className="mt-8 grid grid-cols-1 gap-8 sm:grid-cols-2" data-id="element-348" data-mp="3uc26su1xm356">
        <label className="block" data-id="element-349" data-mp="3ua7kpcexc4zi">
          <span className="label block text-paper/40" data-id="element-350" data-mp="3pcz2xcxou2ys">Client Name</span>
          <input value={draft.client} onChange={event => edit({
          client: event.target.value
        })} className={FIELD} data-id="element-351" data-mp="3pauymtvvn1xz" />
        </label>
        <label className="block" data-id="element-352" data-mp="lunukm9jv2oo">
          <span className="label block text-paper/40" data-id="element-353" data-mp="lufg4pxs3pbd">Project Name</span>
          <input value={draft.name} onChange={event => edit({
          name: event.target.value
        })} className={FIELD} data-id="element-354" data-mp="2g4w26nb2dh71" />
        </label>
        <label className="block" data-id="element-355" data-mp="26d86ga7h5dzr">
          <span className="label block text-paper/40" data-id="element-356" data-mp="26c6t1z2zkfev">Project Type</span>
          <input value={draft.type} onChange={event => edit({
          type: event.target.value
        })} placeholder="e.g. Event Coverage" className={FIELD} data-id="element-357" data-mp="2bc2w9w3v02td" />
        </label>
        <div className="block" data-id="element-358" data-mp="21ghqdmvo6iec">
          <span className="label block text-paper/40" data-id="element-359" data-mp="1nfoscs65t56h">Project Status</span>
          <p className="mt-3 border-b border-paper/25 pb-2 font-sans text-sm tracking-wide2 text-paper" data-id="element-360" data-mp="1nhi3ajnt2bka">
            {projectStatus(activeProject)}
          </p>
          <span className="label-sm mt-3 block text-paper/30" data-id="element-361" data-mp="3huhk2g3x9bt5">
            Set automatically from the deliverables
          </span>
        </div>
        <label className="block" data-id="element-362" data-mp="3mq6ooxustiwb">
          <span className="label block text-paper/40" data-id="element-363" data-mp="qafqwuwdbqz">Next Shoot Date</span>
          <input type="date" value={draft.nextShootDate} onChange={event => edit({
          nextShootDate: event.target.value
        })} className={FIELD} data-id="element-364" data-mp="3rxd3febj0zwg" />
        </label>
        <label className="block" data-id="element-365" data-mp="4s5dxshj790j">
          <span className="label block text-paper/40" data-id="element-366" data-mp="4r43nq8caqjv">Next Shoot Time (optional)</span>
          <input value={draft.nextShootTime} onChange={event => edit({
          nextShootTime: event.target.value
        })} placeholder="e.g. 10:00 AM" className={FIELD} data-id="element-367" data-mp="jgiaaqkj6tvk" />
        </label>
        <label className="block" data-id="element-368" data-mp="sg5fzokamluf">
          <span className="label block text-paper/40" data-id="element-369" data-mp="ogxsbvfrcpjv">Shoot Location (optional)</span>
          <input value={draft.location} onChange={event => edit({
          location: event.target.value
        })} placeholder="e.g. Portal Studio A · Al Quoz" className={FIELD} data-id="element-370" data-mp="2u9mmuq0lnio4" />
        </label>
        <div className="block" data-id="element-371" data-mp="2ro54lokwz227">
          <span className="label block text-paper/40" data-id="element-372" data-mp="2rowvwn7hadmo">Call Sheet (optional)</span>
          {draft.callSheet ? <>
              <p className="mt-3 truncate border-b border-paper/25 pb-2 font-sans text-sm tracking-wide2 text-paper" data-id="element-373" data-mp="30q4lmgvxi655">
                {draft.callSheet.fileName}
              </p>
              <div className="mt-3 flex items-center gap-6" data-id="element-374" data-mp="35mllg8chq8y2">
                <button type="button" onClick={() => fileInput.current?.click()} className="label text-paper/50 transition-colors duration-150 ease-out hover:text-paper" data-id="element-375" data-mp="29002eljwnp5i">
                  Replace
                </button>
                <button type="button" onClick={() => edit({
              callSheet: undefined
            })} className="label text-paper/35 transition-colors duration-150 ease-out hover:text-paper" data-id="element-376" data-mp="2mr555wikkxk2">
                  Remove
                </button>
              </div>
            </> : <button type="button" onClick={() => fileInput.current?.click()} className="label mt-3 w-full border border-paper/25 px-4 py-3 text-left text-paper/50 transition-colors duration-150 ease-out hover:border-paper hover:text-paper" data-id="element-377" data-mp="1mnxdx801hccb">
              Upload PDF
            </button>}
          <input ref={fileInput} type="file" accept="application/pdf,.pdf" onChange={uploadCallSheet} className="hidden" data-id="element-378" data-mp="13sgzl1poib0y" />
        </div>
        <label className="block" data-id="element-379" data-mp="u2e14lzsg4v8">
          <span className="label block text-paper/40" data-id="element-380" data-mp="tz9nky0fnwrw">Main Client Contact</span>
          <input value={draft.clientContact} onChange={event => edit({
          clientContact: event.target.value
        })} placeholder="e.g. Sarah Jones · Marketing Director" className={FIELD} data-id="element-381" data-mp="p4cig269y7ka" />
        </label>
        <label className="block" data-id="element-382" data-mp="6dzc5jv7t2tp">
          <span className="label block text-paper/40" data-id="element-383" data-mp="6cnymsbywgpe">Portal Producer</span>
          <input value={draft.producer} onChange={event => edit({
          producer: event.target.value
        })} placeholder="e.g. Tom — Portal Productions" className={FIELD} data-id="element-384" data-mp="agvmknalpsmk" />
        </label>
      </div>

      <label className="mt-8 block" data-id="element-385" data-mp="1gz453et1pzy">
        <span className="label block text-paper/40" data-id="element-386" data-mp="p4goidvqplsw">Project Description</span>
        <textarea value={draft.description} onChange={event => edit({
        description: event.target.value
      })} rows={3} placeholder="e.g. A three-part leadership series filmed at the client's Dubai office." className={`${FIELD} resize-none`} data-id="element-387" data-mp="u3jx28axia5m" />
      </label>

      <div className="mt-10 flex flex-wrap items-center gap-6" data-id="element-388" data-mp="1832qrw2ztiye">
        <button type="submit" className={BUTTON_SOLID} data-id="element-389" data-mp="181roy1t3yl9x">
          Save Project
        </button>
        <button type="button" onClick={onClose} className={BUTTON_QUIET} data-id="element-390" data-mp="1cwdxzybpw1qu">
          Cancel
        </button>
      </div>
    </form>;
}